// ----------------------------------------------------------------------

const ROOTS = {
	AUTH: "/auth",
	DASHBOARD: "/dashboard",
};

// ----------------------------------------------------------------------

export const paths = {
	// AUTH
	auth: {
		login: `${ROOTS.AUTH}/login`,
	},
	// DASHBOARD
	dashboard: {
		root: ROOTS.DASHBOARD,
		selectUnlockItems: `${ROOTS.DASHBOARD}/select-unlock-items`,
		disableCarrier: `${ROOTS.DASHBOARD}/disable-carrier`,
		profileEdit: `${ROOTS.DASHBOARD}/profile-edit`,
		reports: `${ROOTS.DASHBOARD}/reports`,
		carrierList: `${ROOTS.DASHBOARD}/carriers`,
		createCarrier: `${ROOTS.DASHBOARD}/create-carrier`,
		carrierEdit: `${ROOTS.DASHBOARD}/edit-carrier`,
		addTrip: `${ROOTS.DASHBOARD}/trip/add`,
		addTruck: `${ROOTS.DASHBOARD}/trucks/add`,
		drivers: `${ROOTS.DASHBOARD}/drivers`,
		addDriver: `${ROOTS.DASHBOARD}/drivers/add`,
		trucks: `${ROOTS.DASHBOARD}/trucks`,
		transaction: `${ROOTS.DASHBOARD}/transaction`,
		referral: `${ROOTS.DASHBOARD}/referral`,
		referralUsage: `${ROOTS.DASHBOARD}/referral/usage`,
		allTrips: `${ROOTS.DASHBOARD}/trips`,
		calculator: `${ROOTS.DASHBOARD}/calculator`,
		helpVideo: `${ROOTS.DASHBOARD}/help-video`,
		calculatorScenario: `${ROOTS.DASHBOARD}/calculator/scenario`,
		addLoad: `${ROOTS.DASHBOARD}/load/add`,
		premiumPlan: `${ROOTS.DASHBOARD}/premium-plans`,
		loadManagement: (tripId: number) => `${ROOTS.DASHBOARD}/load-management/${tripId}`,
		editTrip: (tripId: number) => `${ROOTS.DASHBOARD}/trip/edit/${tripId}`,
		loadDetail: (loadId: number) => `${ROOTS.DASHBOARD}/load/${loadId}`,
		tripTracking: (tripId: number) => `${ROOTS.DASHBOARD}/trip-tracking/${tripId}`,
	},
};
